<template>
    <div class="settinghome-container">
        <!-- <div class="tip-row">
            <span class="tip-text">{{ $t('system003') }}</span>
        </div> -->
        <div class="setting-content">
            <div v-for="(list, index) in menu.filter(v => !['site008', 'site009'].includes(v.menuCode))" :key="index" class="page-card-item">
                <div @click="goTo(list)" class="item">
                    <!-- <label class="top"></label> -->
                    <label :class="['bottom', $i18n.locale === 'en' ? 'en-fontSize' : '']">
                        <div class="card-icon">
                            <svg-icon :icon-name="`Setting_${list.href}`" size="32" iconColor="#1e49e2"></svg-icon>
                        </div>
                        <span>{{ $t(list.menuCode) }}</span>
                    </label>
                </div>
            </div>
        </div>
        <div class="setting-title" v-if="menu.filter(v => ['site008', 'site009'].includes(v.menuCode)).length">
            {{ $t('component_team_mgt') }}
        </div>
        <div class="setting-content">
            <div
                class="page-card-item"
                v-for="(v, k) in menu.filter(v => ['site008', 'site009'].includes(v.menuCode))"
                :key="k">
                <div @click="goTo(v)" class="item">
                    <label :class="['bottom', $i18n.locale === 'en' ? 'en-fontSize' : '']">
                        <div class="card-icon">
                            <svg-icon :icon-name="`Setting_${v.href}`" size="32" iconColor="#1e49e2"></svg-icon>
                        </div>
                        <span v-html="$t(`${v.menuCode}_settingHome`)"></span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GuidanceTooltip from '@/components/common/GuidanceTooltip'
import SvgIcon from '@/components/svgIcon/index'

export default {
    name: 'SettingHome',
    components: { GuidanceTooltip,SvgIcon },
    data () {
        return {
            colorList: ['#00338d', '#1797d4', '#6d2077', '#00a3a1', '#00c0ae'],
            cardBgList: ['cardBg1', 'cardBg2', 'cardBg3', 'cardBg4', 'cardBg5'],
            menu: []
        }
    },
    computed: {
        ...mapGetters('common', {
            getUser: 'getUser',
            getCurrentMenu: 'getCurrentMenu',
            getShowMenuCodeList: 'getShowMenuCodeList'
        })
    },
    methods: {
        goTo(data) {
            this.$router.push('/' + data.href)
        }
    },
    mounted() {
        this.getCurrentMenu.forEach((i) => {
            if (i.href === 'settingHome') {
                this.menu = i.childMenuList
                if(!this.getShowMenuCodeList.includes("client007")) {
                    this.menu = this.menu.filter((childMap) => {
                        return !(childMap.href === 'groupReportingUser' || childMap.href === 'groupReportingRole')
                    })
                }
            }
        })

        console.log(123, this.menu)
         
         
         
    }
}
</script>

<style scoped>
.card-icon{
  width: 48px;
  height: 48px;
  line-height:48px;
  text-align: center;
  border-radius: 10px;
  background: #f3f6ff;
  cursor: pointer;
  margin-right: 10px;
  flex-shrink: 0;
}
.settinghome-container {
    width: 100%;
    display: flex;
    flex-direction: column;
}
.settinghome-container .tip-row {
    display: flex;
    flex-direction: row;
    margin: 22px 0 0 22px;
    align-items: center;
}
.settinghome-container .tip-row .tip-text {
    font-size: 40px;
}
.settinghome-container .tip-row .tip-icon {
    margin-left: 20px;
}
.setting-content {
    padding: 22px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    border-radius: 4px;
}
.page-card-item {
    margin-right: 30px;
    margin-bottom: 30px;
    width: calc((100% - 120px) / 5);
    height: 125px;
    background-color: #fff;
    border-radius: 4px 4px 8px 8px;
}
.page-card-item:nth-child(5n) {
    margin-right: 0;
}
.setting-content .item {
    height: 100%;
}
.setting-content .item:hover {
    border-radius: 4px 4px 8px 8px;
    border: 1px solid #3879eb;
    box-shadow: 0 0 15px rgba(56, 121, 235, 0.4);
}
.item label {
    width: 100%;
    display: block;
    font-style: normal;
    font-size: 20px;
    text-align: center;
    cursor: pointer;
}
.item label.en-fontSize {
    font-size: 20px;
}

.item .top {
    height: 12px;
    background-color: #3879eb;
    border-radius: 4px 4px 0 0;
}

.item .bottom {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
    color: #00338d;
    padding: 0 15px;
    border-radius: 5px;
}
.item .bottom span {
    display: inline-block;
    font-size: 30px;
}

.setting-title {
    font-size: 14PX;
    border-left: solid 5px #3879eb;
    padding-left: 5PX;
    font-weight: 600;
    margin-left: 22px;
    color: #2a374d;
}


</style>
